import { AppId } from '@shared/types'
import { VisuallyHidden } from '@ui-components/decorative/VisuallyHidden'
import { createContext, ReactNode, useState } from 'react'
import { useIntl } from 'react-intl'
import * as R from 'remeda'

import { getAppTitle } from '../utils/helpers'

export type PageTitleContextType = {
  pageTitle: string
  setPageTitle: (title: string) => void
}

export const PageTitleContext = createContext<PageTitleContextType>({ pageTitle: '', setPageTitle: R.doNothing() })

export const PageTitleProvider = ({ children, appId }: { children: ReactNode; appId: AppId }) => {
  const [pageTitle, setPageTitle] = useState('')

  return (
    <PageTitleContext.Provider value={{ pageTitle, setPageTitle }}>
      <SiteTitle appId={appId} pageTitle={pageTitle} />
      {children}
    </PageTitleContext.Provider>
  )
}

const SiteTitle = ({ appId, pageTitle }: { appId: AppId; pageTitle: string }) => {
  const intl = useIntl()
  const appTitle = getAppTitle(intl, appId)
  const title = pageTitle ? `${pageTitle} - ${appTitle}` : appTitle

  return (
    <>
      <title>{title}</title>
      <VisuallyHidden tabIndex={-1}>
        <div aria-live="polite">{title}</div>
      </VisuallyHidden>
    </>
  )
}
